export const downloadBlob = (data: Blob, fileName: string, mimeType: string): any => {
  const file = new Blob([data], {type: mimeType});
  const downloadURL = window.URL.createObjectURL(file);
  const link = document.createElement('a');
  link.href = downloadURL;
  link.target = '_blank';
  link.download = fileName;
  link.click();
}
